import { useEffect, useState } from 'react';
import { BaseUserInfo } from '../interface/BaseUserInfo';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import api from '../api/CallManagerApi';
import { toast } from 'react-toastify';
import { toastConfig } from '../utils';
import { PHASE } from '../enum/PhaseEnum';
import ShowWorkConfirm from '../components/ShowWorkConfirm';
import { refreshAll } from '../../store/filterReducer';
import { useDispatch } from 'react-redux';
import { startLoading, stopLoading } from '../../store/loadingReducer';
import { useErrorBoundary } from 'react-error-boundary';
import {
  getRequiredLessonTmpById,
  getRequiredMediaCategoryTmpById,
  getSubBigMediaCategoryTmpById,
  getRequiredMediaTmpById,
  getRequiredWorksTmpById,
  removeAllTmpDataById,
} from '../localStorageUtils';
import Axios from 'axios';

const RegisterWorkConfirm: React.FunctionComponent = () => {
  const [userInfo, setUserInfo] = useState<BaseUserInfo>({} as BaseUserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showBoundary } = useErrorBoundary();

  const save = () => {
    const saveReports = async () => {
      dispatch(startLoading());
      const defaultUser = await api.getDefaultUser();
      try {
        const lesson = getRequiredLessonTmpById(userInfo._id);
        const mediaCategoryStr = getRequiredMediaCategoryTmpById(userInfo._id);
        const subBigMediaCategoryStr = getSubBigMediaCategoryTmpById(userInfo._id);
        const mediaInfo = getRequiredMediaTmpById(userInfo._id);
        const works = getRequiredWorksTmpById(userInfo._id);
        const mediaCategoryArray = mediaCategoryStr.split(',');
        if (subBigMediaCategoryStr) mediaCategoryArray.unshift(subBigMediaCategoryStr);
        const media = { categories: mediaCategoryArray, info: mediaInfo };
        for (const work of works) {
          const workInfo = { subCategory: work.subCategory, info: work.formData };
          await api.postReport(lesson, media, workInfo, PHASE.USER_CONFIRMED, defaultUser);
        }
        navigate('/manager/reports');
      } catch (e: any) {
        if (!Axios.isAxiosError(e)) showBoundary(e);
        if (e.response.status === 400) {
          toast.error('利用報告を作成できませんでした。', toastConfig());
          navigate('/manager/reports');
        } else {
          showBoundary(e.response);
        }
      } finally {
        dispatch(stopLoading());
        removeAllTmpDataById(userInfo._id);
        // 一覧の検索条件初期化
        dispatch(refreshAll());
      }
    };
    saveReports();
  };

  useEffect(() => {
    const getData = async () => {
      const profile: BaseUserInfo = await api.getProfile();
      setUserInfo(profile);
    };
    getData();
  }, []);

  return (
    <>
      <Container>
        <ShowWorkConfirm userInfo={userInfo} saveReports={save} />
      </Container>
    </>
  );
};
export default RegisterWorkConfirm;
